import { Col, Row,Image } from 'antd';
import React, {useEffect, useState,useRef} from 'react';
import './index.css'
import {useSelector} from 'react-redux';
import CreateChatApp from '../../../comm/createChat'
import {getHistoryMessages} from "../../../api/other";
import Question from "./translateQuestion";
import Answer from "./translateAnswer";
import Answer2 from "./translateAnswer/sse";


const TranslateApp = (props) => {
    const {sendTxt, setSendTxt,clearContent,setClearContent,setHomePageIndex,homePageIndex} = props
    const {size} = useSelector(state => state.fontSizeChange)
    const {userInfo, allContextMeta} = useSelector(state => state.user)
    var translating_meta = null;
    if(userInfo&&allContextMeta){
        translating_meta = allContextMeta.translating_meta
    }
    const sizeStyle = {
        fontSize: size === '小' ? '15px' : (size === '中' ? '18px' : '22px')
    }
    // 会话集合
    const [pageList, setPageList] = useState([])
	const [viewType,setViewType] = useState('instant')
    useEffect(() => {
        if (sendTxt) {
            let list2 = {
                user_content:sendTxt.user_content,
				responder_content:[{state:true}]
            }
			pageList.push(list2)
			setViewType('smooth')
            setPageList([...pageList])
			// setSendTxt(null)
        }
    }, [sendTxt])
	useEffect(()=>{
		handleScrollContainer()
	},[pageList])
    var isReload = false
    useEffect(() => {
        if (!isReload&&clearContent) {
            isReload = true
            if(translating_meta) getHisList()
            setTimeout(()=>{
                isReload = false
                setClearContent(false)
            },1000)
        }
    }, [clearContent])
    useEffect(() => {
        if (!isReload) {
            isReload = true
            if(translating_meta) getHisList()
            setTimeout(() => {
                isReload = false
            }, 1000)
        }
    }, [homePageIndex])
    const handleScrollContainer = ()=>{
		chatEndRef.current?.scrollIntoView({ behavior: viewType })
    }

    //获取历史记录
    const getHisList = (n) => {
         getHistoryMessages({context_id: translating_meta?.context_id}).then(res => {
            if (res.code === 200) {
				setViewType('instant')
                setPageList(res.data)
            }
        })
    }
	const chatEndRef = useRef(null);
    return (
        <div className='bg'>
            <div className='bgWrap' id={'scrollable-element'}>
                {
                    pageList && pageList.length > 0 ?
                        pageList.map((res,i) => {
                            return (
                                <div key={'tran'+i}>
                                    {res?.user_content?
                                        <div className="question">
                                            <Row>
                                                <Col span={1}> </Col>
                                                <Col span={19} className="questionInfo" style={sizeStyle}>
                                                    <Question question={res.user_content}/>
                                                </Col>
                                                <Col className='headPortrait' span={4}>
                                                    <Image preview={false} src={userInfo?.avatar} width={30}/>
                                                </Col>
                                            </Row>
                                        </div>:''}
                                    {
                                        res?.responder_content?
                                            <div className="answer">
                                                <Row>
                                                    <Col span={4} className="answerHeadPortrait">
                                                        <Image preview={false}
                                                        	   src={translating_meta.responder_avatar?translating_meta.responder_avatar:require('../../../assets/comm/ai-chat-t-head.png')}
                                                        	   width={30} height={30} style={{borderRadius:'50%'}}/>
                                                    </Col>
                                                    <Col span={19}>
														{
															res?.responder_content[0]?.state===true?
															<Answer2 setSendTxt={setSendTxt} sendTxt={sendTxt} answer={res}/>:
															<Answer setSendTxt={setSendTxt} sendTxt={sendTxt} answer={res.responder_content} />
														}
														<div style={{marginTop:'10px',color:'#c1c1c1'}}>model: {translating_meta.responder}</div>
                                                    </Col>
                                                    <Col span={1}> </Col>
                                                </Row>
                                                {/* <CreateChatApp addParam={res?.responder_content[0]?.state===true?JSON.parse(localStorage.getItem('ai-chat-tran-data')):res} originalScenario={'translating'} setHomePageIndex={setHomePageIndex}/> */}
                                                <CreateChatApp addParam={res} originalScenario={'translating'} setHomePageIndex={setHomePageIndex}/>
                                            </div>:''
                                    }
                                </div>
                            )
                        })
                        : ''
                }
				<div ref={chatEndRef} />
            </div>
        </div>
    )
};
export default TranslateApp;
